'use client'

import { useWalletAuthSession } from '@/domain/hooks/useWalletAuthSession'

export function WalletSessionSync() {
  useWalletAuthSession()

  return null
}
